import axios from 'axios';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { setDomainData, setPartnerConfig } from '../Redux/DomainRedux';
import { getValidAccessToken } from '../Services/oauthServices';
import { fetchPartnerSmsConfig } from '../Redux/PartnerSmsConfigRedux';

const domainMiddleware = (store) => (next) => async (action) => {
  if (action.type === 'domain/checkDomain') {
    try {
      NProgress.start();
      const portal_url = window.location.origin;
      const baseUrl = process.env.REACT_APP_API_URL;
      const token = await getValidAccessToken();
      const authHeaders = token
        ? { Authorization: `Bearer ${token}` }
        : {};

      const response = await axios.get(`${baseUrl}/api/v1/medical/partners`, {
        params: { portal_url },
        headers: authHeaders,
      });

      const { PARTNER_ID } = response.data.data[0];
      sessionStorage.setItem('PARTNER_ID', PARTNER_ID);
      fetchPartnerSmsConfig(PARTNER_ID, store.dispatch);
      store.dispatch(setDomainData(response.data.data[0]));

      const partnerConfigResponse = await axios.get(
        `${baseUrl}/api/v1/medical/partnerConfig`,
        {
          params: {
            partner_id: PARTNER_ID,
          },
          headers: authHeaders,
        },
      );

      if (partnerConfigResponse?.data?.data?.length) {
        store.dispatch(setPartnerConfig(partnerConfigResponse.data.data[0]));
      } else {
        console.warn('No partner config found for partner:', PARTNER_ID);
      }
    } catch (error) {
      console.error('Domain Data Fetch Error:', error);
    } finally {
      NProgress.done();
    }
  }
  return next(action);
};


export default domainMiddleware;
